import PropTypes from 'prop-types';
import { Component } from 'react';
import text from 'I18n/utils/unescapedText';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
class LogOutAllSessionsModal extends Component {
  render() {
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      use: "danger",
      message: text('userPreferences.logOutAllSessionsModal.header'),
      description: text('userPreferences.logOutAllSessionsModal.body'),
      confirmLabel: text('userPreferences.logOutAllSessionsModal.affirmButton'),
      confirmUse: "danger",
      onConfirm: this.props.logoutAllSessions,
      rejectLabel: text('userPreferences.logOutAllSessionsModal.cancelButton'),
      onReject: this.props.toggleLogOutAllSessionsModalOpen
    });
  }
}
LogOutAllSessionsModal.propTypes = {
  toggleLogOutAllSessionsModalOpen: PropTypes.func.isRequired,
  logoutAllSessions: PropTypes.func.isRequired
};
export default LogOutAllSessionsModal;